const dataUploads = [
  {
    title: 'Data Upload',
    icon: 'FileTextIcon',
    enableFeature: true,
    children: [
      {
        title: 'Batch Account Creation',
        route: 'batch-account-creation',
        hasPermission: 'BATCH_ACCOUNT_UPLOAD',
        enableFeature: true,
      },
      {
        title: 'Batch Acct Officer Reassign',
        route: 'batch-account-officer-reassign',
        hasPermission: 'BATCH_ACCOUNT_OFFICER_REASSIGNMENT',
        enableFeature: true,
      },
      {
        title: 'Batch Backdating Posting',
        route: 'batch-backdating-posting',
        hasPermission: 'VIEW_BATCH_BACKDATING_POSTING',
        enableFeature: true,
      },
      {
        title: 'Batch Loan Creation',
        route: 'batch-loan-creation',
        hasPermission: 'BATCH_LOAN_UPLOAD',
        enableFeature: true,
      },
      {
        title: 'Batch Loan Disburse',
        route: 'batch-loan-disburse',
        hasPermission: 'VIEW_BATCH_LOAN_DISBURSE',
        enableFeature: true,
      },
      {
        title: 'GL/ Customer Upload Posting',
        route: 'batch-gl-customer-posting',
        hasPermission: 'VIEW_BATCH_GL_CUSTOMER_UPLOAD_POSTING',
        enableFeature: true,
      },
      {
        title: 'Batch Individual Customer',
        route: 'batch-individual-customer',
        hasPermission: 'BATCH_ACCOUNT_UPLOAD',
        enableFeature: true,
      },
      {
        title: 'Batch Loan Termination',
        route: 'batch-loan-termination',
        hasPermission: 'REPAY_LOAN',
        enableFeature: true,
      },
      {
        title: 'Batch Upload Posting Tracer',
        route: 'batch-upload-posting-tracer',
        hasPermission: 'VIEW_BATCH_GL_CUSTOMER_UPLOAD_POSTING',
        enableFeature: true,
      },
      {
        title: 'Batch Account Status Update',
        route: 'batch-account-status-update',
        hasPermission: 'BATCH_ACCOUNT_UPDATE',
        enableFeature: true,
      },
      {
        title: 'Batch Loan Schedule',
        route: 'batch-loan-schedule',
        hasPermission: 'MODIFY_PAYMENT_SCHEDULE',
        enableFeature: true,
      },
    ],
  },
]

export default dataUploads
